import * as React from "react";
import { Divider } from "antd";
import { useCpFormValue } from "../../../gvc/testNewForm/utils";
import { CpFormItem } from "../../../gvc/testNewForm/CpFormItem";
import { CpLabel } from "../../../gvc/testNewForm/CpLabel";
import { CpErrorWarning } from "../../../gvc/testNewForm/CpErrorWarning";
import { CpInput } from "../../../gvc/testNewForm/CpInput";
import { CpSwitch } from "../../../gvc/testNewForm/CpSwitch";
import { CpTooltip } from "../../../gvc/testNewForm/CpTooltip";

interface Props {}
export const AddonLogs: React.FC<Props> = ({}) => {
  const isEnabled = useCpFormValue(`addons.logs.isEnabled`);

  if (!isEnabled) {
    return null;
  }

  return (
    <>
      <Divider orientation="left" orientationMargin={0}>
        Add-On | Logs
      </Divider>
      <div id={`addon-logs`} style={{ scrollMarginTop: 200 }}>
        <CpFormItem>
          <CpLabel name={`addons.logs.includeNamespaces`}>Include Namespaces</CpLabel>
          <CpInput name={`addons.logs.includeNamespaces`} style={{ maxWidth: 600 }} />
          <CpErrorWarning name={`addons.logs.includeNamespaces`} />
        </CpFormItem>
        <CpFormItem>
          <CpLabel name={`addons.logs.excludeNamespaces`}>Exclude Namespaces</CpLabel>
          <CpInput name={`addons.logs.excludeNamespaces`} style={{ maxWidth: 600 }} />
          <CpErrorWarning name={`addons.logs.excludeNamespaces`} />
        </CpFormItem>
        <CpFormItem>
          <div className="flex items-center gap-2">
            <CpLabel name={`addons.logs.auditEnabled`}>Audit Enabled</CpLabel>
            <CpSwitch name={`addons.logs.auditEnabled`} />
          </div>
        </CpFormItem>
        <CpFormItem>
          <div className="flex items-center gap-2">
            <CpLabel name={`addons.logs.docker`}>Docker</CpLabel>
            <CpSwitch name={`addons.logs.docker`} />
            <CpTooltip tooltipProps={{ title: `Collect docker logs if docker is also running.` }} />
          </div>
        </CpFormItem>
        <CpFormItem>
          <div className="flex items-center gap-2">
            <CpLabel name={`addons.logs.events`}>Events</CpLabel>
            <CpSwitch name={`addons.logs.events`} />
            <CpTooltip tooltipProps={{ title: `Collect K8S events from all namespaces.` }} />
          </div>
        </CpFormItem>
        <CpFormItem>
          <div className="flex items-center gap-2">
            <CpLabel name={`addons.logs.kernel`}>Kernel</CpLabel>
            <CpSwitch name={`addons.logs.kernel`} />
            <CpTooltip tooltipProps={{ title: `Collect kernel logs.` }} />
          </div>
        </CpFormItem>
        <CpFormItem>
          <div className="flex items-center gap-2">
            <CpLabel name={`addons.logs.kubelet`}>Kubelet</CpLabel>
            <CpSwitch name={`addons.logs.kubelet`} />
            <CpTooltip tooltipProps={{ title: `Collect kubelet logs from journald.` }} />
          </div>
        </CpFormItem>
      </div>
    </>
  );
};
